import {ContentListBaseContainer} from './content-list-base-container';
import {SearchContainer} from '../search-container';
import {OperationContainer} from '../operation-container';
import {SearchResultViewType} from '../search-result-view-type.enum';

export class ContentListContainer implements ContentListBaseContainer {
  searchContainer: SearchContainer;
  operationContainer: OperationContainer;
  refreshCallback;
  resultViewName = SearchResultViewType.CONTENT_LIST;
}
